<template>
  <!-- PC：居中弹窗 -->
  <Modal
    v-if="isPC"
    :show="show"
    :closable="true"
    content-width="700px"
    body-class="pt-[60px]"
    @update:show="emit('update:show', $event)"
    @close="emit('update:show', false)"
  >
    <ReasonContent
      :show="show"
      :title="title"
      :submit-text="submitText"
      :reasons="reasons"
      :default-code="defaultCode"
      :is-p-c="true"
      @submit="handleSubmit"
    />
  </Modal>

  <!-- H5：底部上拉弹窗 -->
  <Popup
    v-else
    :visible="visible"
    position="bottom"
    round
    size="auto"
    @update:visible="visible = $event"
  >
    <div class="px-[30px] pt-[40px] pb-[64px]">
      <ReasonContent
        :show="show"
        :title="title"
        :submit-text="submitText"
        :reasons="reasons"
        :default-code="defaultCode"
        :is-p-c="false"
        @submit="handleSubmit"
      />
    </div>
  </Popup>
</template>

<script lang="ts">
import { ref, computed, watch } from 'vue-demi';
import { useFegoPageInfo } from '@ark/web-shared/use';
import Popup from '@futuweb/future-ui/es/popup';
import '@futuweb/future-ui/es/popup/style/css';
import Modal from './modal.vue';
import ReasonContent from './reason-content.vue';
import type { PresetReason } from '../../shared/types';
const __sfc_main = {};
__sfc_main.props = {
  show: {
    key: "show",
    required: true,
    type: Boolean
  },
  title: {
    key: "title",
    required: true,
    type: String
  },
  submitText: {
    key: "submitText",
    required: true,
    type: String
  },
  reasons: {
    key: "reasons",
    required: true,
    type: Array
  },
  defaultCode: {
    key: "defaultCode",
    required: false,
    type: [String, null]
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const {
    isPC
  } = useFegoPageInfo();
  const visible = computed({
    get: () => props.show,
    set: (val: boolean) => emit('update:show', val)
  });
  function handleSubmit(reason: {
    presetCode: string;
    label: Record<string, string>;
  }) {
    emit('submit', reason);
  }
  return {
    emit,
    isPC,
    visible,
    handleSubmit
  };
};
__sfc_main.components = Object.assign({
  Modal,
  ReasonContent,
  Popup
}, __sfc_main.components);
export default __sfc_main;
</script>
